import { OverlayScrollbarsComponent, OverlayScrollbarsComponentProps } from "overlayscrollbars-react";
import "overlayscrollbars/overlayscrollbars.css";
import styles from "./Scrollbar.module.css";

// Order of css imports is important!!! overlayscrollbars.css needs to be first and override class Scrollbar.module.css after it
// This is to maintain proper css specificity

export interface ScrollbarOptions extends OverlayScrollbarsComponentProps {
  children: React.ReactNode;
  size?: "default" | "small";
}

export const Scrollbar = ({ size, children, className, ...args }: ScrollbarOptions) => {
  args.options = args.options || {};
  args.options.scrollbars = args.options.scrollbars || {};
  args.options.scrollbars.theme = size === "small" ? styles.sandboxScrollbarThemeSmall : styles.sandboxScrollbarTheme;

  return <OverlayScrollbarsComponent className={className} {...args}>
    {children}
  </OverlayScrollbarsComponent>
}

export const ScrollbarVertical = ({ size, children, className, ...args }: ScrollbarOptions) => {

  args.options = args.options || {};
  args.options.overflow = { ...(args.options.overflow ?? {}), x: "hidden", y: "scroll" };
  args.options.scrollbars = { ...(args.options.scrollbars ?? {}), visibility: "auto", autoHide: "leave", autoHideDelay: 100 }

  return (
    <Scrollbar size={size} className={className} {...args}>
      {children}
    </Scrollbar>
  )
}